import { render } from "./YandexMetrika.vue?vue&type=template&id=30eed707"
import script from "./YandexMetrika.vue?vue&type=script&lang=js"
export * from "./YandexMetrika.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__